import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createLoan } from '../../features/loans/loanAPI';
import { me } from '../../features/auth/authAPI';

function CreditForm() {
    const user = useSelector((state) => state.auth);
    const today = new Date().toISOString().split("T")[0];
    const [isLend, setIsLend] = useState(false);
    const [isBorrow, setIsBorrow] = useState(true);
    const [borrowerUserId, setBorrowerUserId] = useState(user.username);
    const [lenderUserId, setLenderUserId] = useState('');
    const [loanAmount, setLoanAmount] = useState('');
    const [repayedAmount, setRepayedAmount] = useState('');
    const [block, setBlock] = useState('');
    const [coin, setCoin] = useState('');
    const [reason, setReason] = useState('');
    const [days, setDays] = useState('');
    const dispatch = useDispatch();
    const percentages = ['0%', '5%', '10%', '15%', '20%+'];
    /* const amountOptions = [15, 20, 40, 60, 'Other']; */

    const networks = [
        { id: "base", name: "base" },
        { id: "solana", name: "solana" },
        { id: "polygon", name: "polygon" },
        { id: "arbitrum", name: "arbitrum" },
        { id: "optimism", name: "optimism" }
    ];

    const clear = () => {
        setRepayedAmount('');
        setLoanAmount('');
        setReason('');
        setBlock('');
        setCoin('');
        setDays('');
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        const loanData = {
            borrowerUserId,
            lenderUserId,
            loanAmount,
            repayedAmount,
            block,
            coin,
            reason,
            days
        };
        (user.isCivic === "ACTIVE" && block && coin && borrowerUserId !== lenderUserId && (isLend || (isBorrow && user.nal < user.mal && loanAmount <= user.cs))) && await dispatch(createLoan(loanData))
            .unwrap()
            .then(async () => {
                alert('Loan created successfully');
                await dispatch(me())
                    .unwrap()
                    .then(() => {
                        console.log('User fetched successfully');
                    })
                    .catch((error) => {
                        console.error('Error fetching user:', error.message || error);
                    })
            })
            .catch((error) => {
                alert('Error creating loan:', error.message || error);
            });
        clear();
    };

    const handleDays = (e) => {
        const selectedDate = e.target.value;
    
        const today = new Date();
        today.setHours(0, 0, 0, 0);
    
        const date = new Date(selectedDate);
        const timeDifference = date - today;
        const differenceInDays = timeDifference / (1000 * 60 * 60 * 24);
    
        setDays(Math.round(differenceInDays));
    };

    const handleBorrow = () => {
        setBorrowerUserId(user.username);
        setLenderUserId('');
        setIsBorrow(true);
        setIsLend(false);
    };

    const handleLend = () => {
        setLenderUserId(user.username);
        setBorrowerUserId('');
        setIsBorrow(false);
        setIsLend(true);
    };

    return (
        <div className="flex flex-col w-[40%] max-md:ml-0 max-md:w-full">
            <form
                onSubmit={handleSubmit}
                className="flex overflow-hidden relative flex-col grow justify-center p-8 w-full rounded-2xl bg-white bg-opacity-10 shadow-[0px_4px_242px_rgba(0,0,0,0.25)] max-md:px-5 max-md:mt-10 max-md:max-w-full"
                style={{
                    display: isLend && 'none',
                }}
            >
                <div className="flex overflow-hidden flex-col p-5 w-full bg-white rounded-2xl max-md:px-5 max-md:max-w-full">
                    <div className="flex overflow-hidden gap-10 p-1.5 w-full text-lg font-medium text-center rounded-xl border border-solid bg-zinc-100 border-zinc-300 max-md:max-w-full">
                        <button
                            type="button"
                            onClick={handleBorrow}
                            className={isBorrow ? "overflow-hidden gap-5 self-stretch w-[50%] px-5 py-3.5 text-white rounded-lg bg-slate-900 min-h-[48px] max-md:px-5" : "grow shrink my-auto text-black text-opacity-60"}>
                            Ask For Help
                        </button>
                        <button
                            type="button"
                            onClick={handleLend}
                            className={isLend ? "overflow-hidden gap-5 self-stretch w-[50%] px-5 py-3.5 text-white rounded-lg bg-slate-900 min-h-[48px] max-md:px-5" : "grow shrink my-auto text-black text-opacity-60"}>
                            Offer Help
                        </button>
                    </div>

                    <div className={"flex w-[200px] mt-4 h-5 items-center gap-1 px-2 py-0.5 static top-20 left-[25px] bg-[#e2f7f5] rounded-lg"}>
                        <div className="relative w-4 h-4">
                            <img
                                className="absolute w-[13px] h-[11px] top-[3px] left-px"
                                alt="Style"
                                src="https://c.animaapp.com/wawSHnKX/img/style-3.svg"
                            />
                        </div>

                        <p className="relative w-fit mt-[-6.00px] mb-[-6.00px] [font-family:'Geist',Helvetica] font-medium text-black text-[11.5px] tracking-[0] leading-[30px] whitespace-nowrap">
                            Your available credit limit: ${user.cs}
                        </p>
                    </div>

                    <div className="flex gap-1.5 items-center self-start mt-4 text-xl font-medium text-black">
                        <label htmlFor="amount" className="self-stretch my-auto">Set Your Own Terms</label>
                        <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/05cc08dbfdd2c94fcc5f992980c395365e0eb0d49890d06b3f81da4da7b57ab7?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto aspect-square w-[21px]" />
                    </div>

                    <input
                        id="amount"
                        type="text"
                        className="gap-5 self-stretch p-5 mt-1.5 text-lg leading-none bg-white rounded-lg border border-solid border-zinc-300 text-black text-opacity-60 max-md:px-5"
                        placeholder="Enter your amount"
                        value={loanAmount}
                        onChange={(e) => setLoanAmount(e.target.value)}
                    />

                    {/* <div className="flex gap-1.5 items-center self-start mt-2.5 text-lg leading-loose whitespace-nowrap text-zinc-600">
                        {amountOptions.map((amount, index) => (
                            <button
                                key={index}
                                type="button"
                                className="gap-2.5 self-stretch px-4 py-2.5 my-auto rounded-lg border border-solid bg-zinc-100 border-white border-opacity-20"
                            >
                                {typeof amount === 'number' ? `$${amount}` : amount}
                            </button>
                        ))}
                    </div> */}

                    <div className="flex gap-10 justify-between items-center py-2.5 pr-4 pl-4 mt-4 leading-none bg-white rounded-lg border border-solid border-zinc-300 min-h-[61px] max-md:max-w-full">
                        <div className="contents self-stretch my-auto">
                            <label htmlFor="repaymentDate" className="text-sm text-black text-opacity-60">
                                Repayment timeline
                            </label>
                            <input
                                type="date"
                                min={today}
                                id="repaymentDate"
                                className="mt-2.5 text-lg text-black bg-transparent px-2 rounded-lg border border-solid border-zinc-300"
                                onChange={(e) => handleDays(e)}
                            />
                            <input
                                type="number"
                                min="0"
                                id="repaymentTimeline"
                                className="w-[40%] mt-2.5 text-lg text-black bg-transparent px-2 rounded-lg border border-solid border-zinc-300"
                                placeholder="Days"
                                value={days}
                                onChange={(e) => setDays(e.target.value)}
                            />
                        </div>
                        {/* <img loading="lazy" src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/b4db76d14b2001019f9ed321b2f02f1ff717c9a437dc3d0a68c043152f1fa462?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto aspect-square w-[25px]" /> */}
                    </div>

                    <input
                        type="number"
                        min="0"
                        className="gap-5 self-stretch p-5 mt-4 text-lg leading-none bg-white rounded-lg border border-solid border-zinc-300 text-black text-opacity-60 max-md:px-5"
                        placeholder="Enter your payback amount"
                        value={repayedAmount}
                        onChange={(e) => setRepayedAmount(e.target.value)}
                    />

                    <textarea
                        className="gap-5 px-5 pt-5 pb-28 mt-4 text-lg leading-none bg-white rounded-lg border border-solid border-zinc-300 min-h-[159px] text-black text-opacity-60 max-md:px-5 max-md:pb-24"
                        placeholder="Type your reason"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                    />

                    <select
                        value={block}
                        onChange={(e) => setBlock(e.target.value)}
                        className="gap-5 self-stretch p-5 mt-4 text-lg leading-none bg-white rounded-lg border border-solid border-zinc-300 text-black text-opacity-60 max-md:px-5"
                    >
                        <option value="" disabled>
                            Select a network
                        </option>
                        {networks.map((network) => (
                            <option key={network.id} value={network.id}>
                                {network.name}
                            </option>
                        ))}
                    </select>

                    {block && <select
                        value={coin}
                        onChange={(e) => setCoin(e.target.value)}
                        className="gap-5 self-stretch p-5 mt-4 text-lg leading-none bg-white rounded-lg border border-solid border-zinc-300 text-black text-opacity-60 max-md:px-5"
                    >
                        <option value="" disabled>
                            Select a stablecoin
                        </option>
                        {block !== "base" && <option value={"USDT"}>
                            USDT
                        </option>}
                        <option value={"USDC"}>
                            USDC
                        </option>
                    </select>}

                    <button
                        type="submit"
                        className="overflow-hidden gap-5 self-stretch p-5 mt-5 text-lg font-medium leading-none text-center text-white bg-blue-600 rounded-lg max-md:px-5"
                    >
                        Make Your Request
                    </button>
                </div>
            </form>
            <form
                className="flex overflow-hidden relative flex-col grow justify-center p-8 w-full rounded-2xl bg-white bg-opacity-10 shadow-[0px_4px_242px_rgba(0,0,0,0.25)] max-md:px-5 max-md:mt-10 max-md:max-w-full"
                style={{
                    display: isBorrow && 'none',
                }}
            >
                <div className="flex overflow-hidden flex-col p-5 w-full bg-white rounded-2xl max-md:px-5 max-md:max-w-full">
                    <div className="flex overflow-hidden gap-10 p-1.5 w-full text-lg font-medium text-center rounded-xl border border-solid bg-zinc-100 border-zinc-300 max-md:max-w-full">
                        <button
                            type="button"
                            onClick={handleBorrow}
                            className={isBorrow ? "overflow-hidden gap-5 self-stretch w-[50%] px-5 py-3.5 text-white rounded-lg bg-slate-900 min-h-[48px] max-md:px-5" : "grow shrink my-auto text-black text-opacity-60"}>
                            Ask For Help
                        </button>
                        <button
                            type="button"
                            onClick={handleLend}
                            className={isLend ? "overflow-hidden gap-5 self-stretch w-[50%] px-5 py-3.5 text-white rounded-lg bg-slate-900 min-h-[48px] max-md:px-5" : "grow shrink my-auto text-black text-opacity-60"}>
                            Offer Help
                        </button>
                    </div>

                    <h2 className="flex gap-1.5 items-center self-start mt-8 text-xl font-medium text-black">
                        Lend Help
                        <img src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/779b9b37373127dc9d628704623f276344e6ecfbee2cca5a28f088b9737748d5?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square" />
                    </h2>

                    <label htmlFor="maximumLending" className="sr-only">Maximum lending</label>
                    <input
                        id="maximumLending"
                        type="text"
                        className="gap-5 self-stretch px-5 py-4 mt-5 text-sm leading-none bg-white rounded-lg border border-solid border-zinc-300 text-black text-opacity-60"
                        placeholder="Maximum lending"
                    />

                    <p className="self-start mt-4 text-sm leading-6 text-black text-opacity-60">
                        I am expecting a return of
                    </p>

                    <div className="flex gap-1.5 items-center self-start mt-2.5 text-sm leading-6 whitespace-nowrap text-zinc-600">
                        {percentages.map((percentage, index) => (
                            <button
                                key={index}
                                type="button"
                                className="gap-2.5 self-stretch px-3 py-2.5 my-auto rounded-lg border border-solid bg-zinc-100 border-white border-opacity-20"
                            >
                                {percentage}
                            </button>
                        ))}
                    </div>

                    <div className="relative group">
                        <div className="flex gap-10 justify-between items-center p-5 mt-4 text-sm font-medium leading-none text-blue-600 rounded-lg bg-blue-600 bg-opacity-10">
                            <p className="self-stretch my-auto">Your Bonus IOU Tokens</p>
                            <img
                                src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/60708a5ad33ebb5ccf54bfae6fb3a3c0991f08629f6a860ef33502221aafe891?apiKey=e485b3dc4b924975b4554885e21242bb&"
                                alt=""
                                className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
                            />
                        </div>
                        <div className="absolute bottom-12 right-0 w-full p-4 bg-white rounded-lg shadow-md max-w-xs opacity-0 hidden group-hover:opacity-100 group-hover:block transition-opacity duration-300">
                            <ul className="text-gray-800 space-y-2">
                                <li className="flex justify-between">
                                    <span>New borrowers:</span>
                                    <span className="font-semibold">You get 25 IOU</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Second-time borrowers:</span>
                                    <span className="font-semibold">You get 25 IOU</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Third-time borrowers:</span>
                                    <span className="font-semibold">You get 15 IOU</span>
                                </li>
                                <li className="flex justify-between">
                                    <span>Experienced borrowers:</span>
                                    <span className="font-semibold">You get 10 IOU</span>
                                </li>
                            </ul>
                            <div className="mt-3 p-2 bg-green-100 text-green-700 text-center rounded-md font-semibold">
                                Plus 1 IOU token per $1 you lend!
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-10 justify-between items-center px-4 py-2 mt-4 leading-none bg-white rounded-lg border border-solid border-zinc-300">
                        <div className="flex flex-col justify-center self-stretch my-auto">
                            <p className="text-xs text-black text-opacity-60">I prefer lending to</p>
                            <p className="mt-1.5 text-sm text-black">New borrowers</p>
                        </div>
                        <img src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/3986b1982b851452b916dc530bae003c26fb1f49fbf7526e8a1d579754bc148a?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
                    </div>

                    <div className="flex gap-10 justify-between items-center px-4 py-2 mt-4 leading-none bg-white rounded-lg border border-solid border-zinc-300">
                        <div className="flex flex-col justify-center self-stretch my-auto">
                            <p className="text-xs text-black text-opacity-60">Maximum repayment timeline</p>
                            <p className="mt-1.5 text-sm text-black">Days</p>
                        </div>
                        <img src="https://cdn.builder.io/api/v1/image/assets/e485b3dc4b924975b4554885e21242bb/3986b1982b851452b916dc530bae003c26fb1f49fbf7526e8a1d579754bc148a?apiKey=e485b3dc4b924975b4554885e21242bb&" alt="" className="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
                    </div>

                    <button
                        type="submit"
                        className="overflow-hidden gap-5 self-stretch px-5 py-4 mt-8 text-base font-medium leading-none text-center text-white bg-blue-600 rounded-lg"
                    >
                        Start Lending Today
                    </button>
                </div>
            </form>
        </div>
    );
}

export default CreditForm;